import React, { useState, useEffect } from "react";
import { Card, Form } from "react-bootstrap";
import axios from "axios";

function Addyoutube() {
  const [students, setstudents] = useState([]);
  const [teachers, setteachers] = useState([]);
  const [type, settype] = useState("");
  const [youtubetitle, setyoutubetitle] = useState("");
  const [youtubedate, setyoutubedate] = useState("");
  const [youtubelink, setyoutubelink] = useState("");
  const [standard, setstandard] = useState("");
  const [youtubesubject, setyoutubesubject] = useState("");
  const [studentname, setstudentname] = useState("");
  const [teacherid, setteacherid] = useState("");
  const user = JSON.parse(sessionStorage.getItem("admin"));

  useEffect(() => {
    getStudents();
    getTeachers();
  }, []);

  const getStudents = async () => {
    try {
      const res = await axios.get("/api/user/getAllUser1");
      if (res.status === 200) setstudents(res.data.success || []);
    } catch (error) {
      console.log(error);
    }
  };

  const getTeachers = async () => {
    try {
      const res = await axios.get("/api/user/getAllUser");
      if (res.status === 200) {
        setteachers(
          (res.data.success || []).filter((u) => u.role === "Teacher")
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const postimage = async () => {
    if (!youtubetitle || !youtubesubject || !standard || !youtubelink || !type) {
      alert("Please fill all mandatory fields");
      return;
    }
    try {
      const payload = {
        youtubetitle,
        standard,
        adminid: user._id,
        type,
        youtubedate,
        youtubelink,
        youtubesubject,
      };
      if (studentname) payload.studentid = studentname;
      if (teacherid) payload.teacherid = teacherid;

      const res = await axios.post("/api/admin/addyoutube", payload, {
        headers: { "content-type": "application/json" },
      });
      if (res.status === 200) {
        alert("Youtube video added successfully");
        window.location.assign("/admin/youtube");
      }
    } catch (error) {
      console.log(error);
      alert(error?.response?.data?.error || "Something went wrong. Please try again.");
    }
  };

  const classes = [
    "Class 1", "Class 2", "Class 3", "Class 4",
    "Class 5", "Class 6", "Class 7", "Class 8",
    "Class 9", "Class 10", "Class 11", "Class 12",
  ];

  return (
    <div className="container mt-5">
      <Card
        className="text-center"
        style={{
          boxShadow:
            "0 4px 8px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19)",
        }}
      >
        <h5 className="pt-5">Create Youtube Link</h5>
        <Card.Body>
          <Form className="w-50 mx-auto text-start">

            <Form.Group className="mb-3">
              <Form.Label>Youtube Title *</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter title"
                onChange={(e) => setyoutubetitle(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Link *</Form.Label>
              <Form.Control
                type="text"
                placeholder="https://www.youtube.com/watch?v=..."
                onChange={(e) => setyoutubelink(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Subject *</Form.Label>
              <Form.Control
                type="text"
                placeholder="Subject"
                onChange={(e) => setyoutubesubject(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Date</Form.Label>
              <Form.Control
                type="date"
                onChange={(e) => setyoutubedate(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Type *</Form.Label>
              <Form.Select onChange={(e) => settype(e.target.value)} defaultValue="">
                <option value="" disabled>Select Type</option>
                <option value="standard">Whole Class</option>
                <option value="student">Individual Student</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Class *</Form.Label>
              <Form.Select onChange={(e) => setstandard(e.target.value)} defaultValue="">
                <option value="" disabled>Select Class</option>
                {classes.map((c) => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </Form.Select>
            </Form.Group>

            {type === "student" && (
              <Form.Group className="mb-3">
                <Form.Label>Student Name</Form.Label>
                <Form.Select onChange={(e) => setstudentname(e.target.value)} defaultValue="">
                  <option value="">Select Student</option>
                  {students
                    .filter((s) => s.standard === standard)
                    .map((s) => (
                      <option key={s._id} value={s._id}>{s.name}</option>
                    ))}
                </Form.Select>
              </Form.Group>
            )}

            {/* Assign to a specific teacher — if blank, all teachers can see it */}
            <Form.Group className="mb-4">
              <Form.Label>
                Assign to Teacher{" "}
                <span style={{ color: "#888", fontWeight: "normal", fontSize: 13 }}>
                  (optional — leave blank for all teachers)
                </span>
              </Form.Label>
              <Form.Select onChange={(e) => setteacherid(e.target.value)} defaultValue="">
                <option value="">All Teachers</option>
                {teachers.map((t) => (
                  <option key={t._id} value={t._id}>
                    {t.name} — {t.subject}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <button className="btn btn-primary w-100 mb-3" onClick={postimage}>
              Create Youtube Link
            </button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}

export default Addyoutube;
